import { useCallback, useEffect, useMemo, useState } from 'react';
import { getBulkSettlementTableList } from '../bulkSettlement.services';
import type { BulkSettlementOption, BulkSettlementTableItem } from '../types';

export const useBulkSettlementTableSelection = () => {
  const [tables, setTables] = useState<BulkSettlementTableItem[]>([]);
  const [selectedTableId, setSelectedTableId] = useState('');

  useEffect(() => {
    let isMounted = true;

    getBulkSettlementTableList()
      .then((response: any) => {
        if (!isMounted) return;
        const nextTables: BulkSettlementTableItem[] =
          response?.success ? (response?.data?.list ?? []) : [];
        setTables(nextTables);
        setSelectedTableId(nextTables[0]?._id || '');
      })
      .catch((err: unknown) => {
        console.error('Error loading bulk settlement tables', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const selectedTable = useMemo(
    () => tables.find(t => t._id === selectedTableId) ?? null,
    [selectedTableId, tables],
  );

  const resolvedTableCapacity = Number(selectedTable?.capacity) || 0;

  const tableOptions = useMemo<BulkSettlementOption[]>(
    () => tables.map(t => ({ label: String(t.table_number ?? ''), value: t._id })),
    [tables],
  );

  const updateSelectedTable = useCallback(
    (tableId: string) => {
      const nextTable = tables.find(t => t._id === tableId) ?? null;
      setSelectedTableId(tableId);
      return nextTable;
    },
    [tables],
  );

  return { resolvedTableCapacity, selectedTableId, tableOptions, updateSelectedTable };
};
